export default __webpack_public_path__ + "static/media/Conference.98a34ffd.jpg";